// Applies progressive date mask (mm/dd/yyyy) to p-datepicker inputs with validation
import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';
declare var jQuery: any;
const DATE_MASK = 'mm/dd/yyyy';

@Directive({
  selector: 'p-datepicker[dateMask]',
  standalone: true
})
export class DateMaskDirective implements AfterViewInit, OnDestroy {
  constructor(
    private el: ElementRef<HTMLElement>
  ) { }

  ngAfterViewInit() {
    if (typeof jQuery !== 'function') {
      return;
    }

    this.applyInputMask();
  }

  ngOnDestroy() {
    const JqCalendarInputSelector = this.jQueryCalenderInputSelector();
    if (JqCalendarInputSelector) {
      JqCalendarInputSelector.inputmask('remove');
    }
  }

  // Find native input inside PrimeNG p-datepicker
  private get calendarHtmlInput(): HTMLInputElement | null {
    return this.el.nativeElement.querySelector('input');
  }

  // Apply jQuery inputmask with progressive display (mm/dd/yyyy)
  private applyInputMask() {
    const JqCalendarInputSelector = this.jQueryCalenderInputSelector();
    if (!JqCalendarInputSelector) return;

    JqCalendarInputSelector.inputmask('remove');
    JqCalendarInputSelector.inputmask(DATE_MASK, {
      clearIncomplete: false,
      showMaskOnHover: false,
      oncomplete: () => {
        this.calendarHtmlInput?.dispatchEvent(new Event('input', { bubbles: true }));
      },
      onKeyValidation: () => jQuery('div').remove('.p-datepicker-panel')
    });
  }
  
  // Returns the jQuery selector result for the calendar input.
  private jQueryCalenderInputSelector(): any {
    if (!this.calendarHtmlInput) return null;
    const JqCalendarInputSelector = jQuery(this.calendarHtmlInput);
    return typeof JqCalendarInputSelector.inputmask === 'function' ? JqCalendarInputSelector : null;
  }
}